import api, { apiErrorHandler } from "api";
import { StatsParams } from "api/types";
import { AxiosError, AxiosResponse } from "axios";

const requestHandler =
  (request: (params: StatsParams) => Promise<AxiosResponse>) =>
  (
    params: StatsParams,
    onLoading: (status: boolean) => void,
    onSuccess: (res: any) => void,
    onError?: (err: AxiosError) => void,
  ) => {
    onLoading(true);
    return request(params)
      .then((res) => {
        if (res.data) onSuccess(res.data);
        onLoading(false);
      })
      .catch(
        apiErrorHandler((error) => {
          onLoading(false);
          if (onError) onError(error);
        }),
      );
  };

export const handleGetMissingDeliveries = async (
  params: StatsParams,
  onLoading: (status: boolean) => void,
  onSuccess: (res: any) => void,
  onError?: (err: AxiosError) => void,
) => {
  return await requestHandler(api.getStatsMissing)(params, onLoading, onSuccess, onError);
};

export const handleGetCashOnDelivery = async (
  params: StatsParams,
  onLoading: (status: boolean) => void,
  onSuccess: (res: any) => void,
  onError?: (err: AxiosError) => void,
) => {
  return await requestHandler(api.getStatsCash)(params, onLoading, onSuccess, onError);
};

export const handleGetReliabilityScores = async (
  params: StatsParams,
  onLoading: (status: boolean) => void,
  onSuccess: (res: any) => void,
  onError?: (err: AxiosError) => void,
) => {
  return await requestHandler(api.getReliabilityScores)(params, onLoading, onSuccess, onError);
};

export const handleGetRabbitReports = async (
  params: StatsParams,
  onSuccess: (res: any) => void,
  onLoading: (status: boolean) => void,
  onError?: (err: AxiosError) => void,
) => {
  return await requestHandler(api.getRabbitReports)(params, onLoading, onSuccess, onError);
};

export const handleGetDollyReports = async (
  params: StatsParams,
  onSuccess: (res: any) => void,
  onLoading: (status: boolean) => void,
  onError?: (err: AxiosError) => void,
) => {
  return await requestHandler(api.getDollyReports)(params, onLoading, onSuccess, onError);
};

